<template>
  <div class="table-loader">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: "TableLoader",
  props: {
    message: {
      type: String,
      default: "Loading…",
    },
  },
};
</script>

<style scoped>
.table-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 64px 24px;
  text-align: center;
  color: var(--ehs-color-muted);
  font-size: 0.9rem;
  font-weight: 500;
}

.table-loader .pi {
  font-size: 1.7rem;
  color: var(--ehs-color-primary);
}

@media (max-width: 991.98px) {
  .table-loader {
    padding: 44px 16px;
    gap: 10px;
    font-size: 0.84rem;
  }

  .table-loader .pi {
    font-size: 1.45rem;
  }
}
</style>
